import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { DiscountCartProgressContent } from "./discount-cart-progress-content";
import { DiscountCartProgressHeader } from "./discount-cart-progress-header";
import { useDiscountCartProgress } from "./use-discount-cart-progress";

export const DiscountCartProgress = ({
  onlyHeader = false,
  className,
}: {
  onlyHeader?: boolean;
  className?: string;
}) => {
  const {
    currentDiscountAmountLabel,
    currentDiscountLabel,
    discountType,
    discountConfig,
    displayOnlyHeader,
    handleAddDaysToCart,
    hasMultipleDiets,
    isAddDaysDisabled,
    messageVariant,
    nextTier,
    progressTiers,
    progressValue,
    shouldShowAlreadyHaveDiscount,
    shouldShowContent,
  } = useDiscountCartProgress({
    onlyHeader,
  });

  if (hasMultipleDiets || !discountConfig || progressTiers.length === 0) {
    return null;
  }

  return (
    <Card
      className={cn(
        "border bg-background p-0 md:sticky",
        displayOnlyHeader && "border-none",
        className,
      )}
    >
      <DiscountCartProgressHeader
        currentDiscountAmountLabel={currentDiscountAmountLabel}
        currentDiscountLabel={currentDiscountLabel}
        discountType={discountType}
        displayOnlyHeader={displayOnlyHeader}
        messageVariant={messageVariant}
        nextTier={nextTier}
        shouldShowAlreadyHaveDiscount={shouldShowAlreadyHaveDiscount}
      />
      {shouldShowContent && (
        <DiscountCartProgressContent
          isAddDaysDisabled={isAddDaysDisabled}
          nextTier={nextTier}
          onAddDays={handleAddDaysToCart}
          progressTiers={progressTiers}
          progressValue={progressValue}
        />
      )}
    </Card>
  );
};
